import CustomHead from 'components/commons/CustomHead'
import TopicsPressRelease from 'components/topics/pressrelease/page/PageId'
import { wpApiUrl } from 'lib/url'
import WPAPI from 'wpapi'

interface Event {
  id: number
  title: {
    rendered: string
  }
  thumbnail_img?: string
  content: {
    rendered: string
  }
  date: string
  category_name: string
  start_date?: string
  end_date?: string
  duration?: string
}

interface newsIdItems {
  posts: {
    id: number
    title: {
      rendered: string
    }
    content: {
      rendered: string
    }
  }
  page: number
  totalPageNumber: number
  activeEvents?: Event[]
}
const newsId: React.FC<newsIdItems> = ({ posts, page, totalPageNumber, activeEvents }) => (
  <>
    <CustomHead
      keyword={'ニュース 最新情報 プレスリリース イベント セミナー'}
      image={'https://www.i3design.jp/ogp_logo.png'}
      url={`https://www.i3design.jp/pressrelease/page/${page}`}
      title="プレスリリース | i3DESIGN アイスリーデザイン"
      description="i3DESIGN（アイスリーデザイン）のプレスリリースの情報を掲載しています。"
    />
    <TopicsPressRelease posts={posts} page={page} totalPageNumber={totalPageNumber} activeEvents={activeEvents} />
  </>
)

interface Props {
  paths: string[]
  fallback: false
}

export async function getStaticPaths(): Promise<Props> {
  const wpnews = new WPAPI({ endpoint: wpApiUrl })
  const header = await wpnews.posts().categories(1).headers()
  const totalPageNumber = parseInt(header['x-wp-totalpages'])
  const pages = []
  for (let i = 1; i <= totalPageNumber; i++) {
    pages.push(i)
  }

  const paths = pages.map((page) => `/pressrelease/page/${page}`)
  return {
    paths,
    fallback: false,
  }
}

interface Post {
  props: {
    posts: {
      id: number
      title: {
        rendered: string
      }
      content: {
        rendered: string
      }
    }
    page: number
    totalPageNumber: number
    activeEvents?: Event[]
  }
}

export async function getStaticProps({ params }): Promise<Post> {
  const page = parseInt(params.id, 10) || 1
  const wpnews = new WPAPI({ endpoint: wpApiUrl })
  let posts = await wpnews.posts().categories(1).page(page)
  const eventPosts = await wpnews.posts().categories(3).perPage(100)
  const header = await wpnews.posts().categories(1).headers()
  const totalPageNumber = parseInt(header['x-wp-totalpages'])

  const currentDate = new Date().toISOString()
  let activeEvents = eventPosts
    .filter((post) => post.end_date && new Date(post.end_date).toISOString() >= currentDate)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 5)

  // サムネイル画像URLを変換し、undefinedをnullに置き換える
  activeEvents = activeEvents.map((event) => {
    const updatedThumbnail = event.thumbnail_img
      ? event.thumbnail_img.split('https://cms-admin.i3design.jp/wp-content/uploads').join('/images/wp')
      : null
    return {
      ...event,
      thumbnail_img: updatedThumbnail,
    }
  })

  // posts のサムネイル画像URLを変換
  posts = posts.map((post) => {
    const updatedThumbnail = post.thumbnail_img
      ? post.thumbnail_img.split('https://cms-admin.i3design.jp/wp-content/uploads').join('/images/wp')
      : null
    return {
      ...post,
      thumbnail_img: updatedThumbnail,
    }
  })

  return {
    props: {
      posts,
      page,
      totalPageNumber,
      activeEvents,
    },
  }
}

export default newsId
